// NPM Imports
import React from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "@revvsales/components";

const ConvertToImageFieldBtn = props => (
  <Tooltip
    placement="top"
    overlay="This will convert the image block into a placeholder. User can upload image here at the time of doc creation or allow recipient to do so while sharing documents."
    align={{ offset: [0, 3] }}>
    <span
      className={`image-form-field-btn convert-field-btn ${
        !props.btnTitle ? " only-icon " : ""
      }`}
      data-test="convert-to-image-field"
      onMouseDown={() => props.btnAction(props.id)}
      onKeyDown={() => {}}
      role="button"
      tabIndex={0}>
      <span className="image-form-field-icon">[+]</span>
      {props.btnTitle}
    </span>
  </Tooltip>
);

export default ConvertToImageFieldBtn;



// WEBPACK FOOTER //
// ./src/components/DocumentItems/ConvertToImageFieldBtn/ConvertToImageFieldBtn.js